import React from 'react';
import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { Checkbox, FormFeedback } from '@morressier/alembic';
import { FormFieldCheckbox } from '@publishing-engine/domain/types/article';
import { Box, Flex, Text } from '@chakra-ui/react';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';

interface AgreementFormFieldCheckboxProps {
  config: FormFieldCheckbox;
  isEditingAllowed?: boolean;
}

const FormFieldAgreementCheckbox: React.FC<AgreementFormFieldCheckboxProps> = ({
  config,
  isEditingAllowed = true
}) => {
  const {
    register,
    formState: { errors }
  } = useFormContext();
  const {
    name,
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;

  const error = get(errors, field);

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <Checkbox
        ariaLabel={labels.main}
        id={name}
        {...register(field, { required: validations.required })}
        isDisabled={!isEditingAllowed}
      >
        <Flex alignItems="flex-start" gap={2}>
          <Text textStyle="headingItem">
            {parseStringWithLinks(labels.main)}
          </Text>
          {validations.required && (
            <Box
              as="span"
              color="actionSecondaryCautionContent"
              textStyle="headingItem"
            >
              *
            </Box>
          )}
        </Flex>
        <Text textStyle="textBody">
          {labels.content
            ? parseStringWithLinks(labels.content)
            : parseStringWithLinks(labels.subtitle)}
        </Text>
      </Checkbox>
      {error && (
        <FormFeedback variant="error">
          Please agree to the terms of the {labels.main} to proceed.
        </FormFeedback>
      )}
    </Flex>
  );
};

export default FormFieldAgreementCheckbox;
